import deDE from "antd/locale/de_DE";
import enUS from "antd/locale/en_US";
import esES from "antd/locale/es_ES";
import frFR from "antd/locale/fr_FR";
import nlNL from "antd/locale/nl_NL";
import plPL from "antd/locale/pl_PL";
import ptPT from "antd/locale/pt_PT";

export const ANTD_LOCALE = {
  en: enUS,
  es: esES,
  fr: frFR,
  de: deDE,
  nl: nlNL,
  pl: plPL,
  pt: ptPT,
};
